import IconCircleRight from "../components/IconCircleRight";
import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import style from "./CategoryList.module.css";
import Image from "../components/shared/Image";
import SalesBanner from "../components/SalesBanner";

function CategoryList(props) {
  return (
    <div className={style.contentWrapper}>
      <SalesBanner categoryId={0} />
      <div className={style.rootWrapper}>
        <ul className={style.root}>
          {props.categoryTree.map(category => {
            const url = `/category/${category.id}`;

            return (
              <li key={category.id}>
                <Link to={url} className={style.link}>
                  <Image
                    src={category.image}
                    alt={category.text}
                    className={style.image}
                  />
                  <span className={style.name}>
                    {category.name}&nbsp;
                    <IconCircleRight fill="#ca0000" />
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

export default connect(({ categoryTree }) => ({ categoryTree }))(CategoryList);
